import React from 'react';
import PropTypes from 'prop-types';

const LoadingWrapper = ({ text }) => <div className="loading">
  { text != null && <span>{ text }</span> }
</div>;

LoadingWrapper.propTypes = {
  text: PropTypes.string
};

LoadingWrapper.defaultProps = {
  text: null
};

export default LoadingWrapper;
